import React from 'react'

import Container from 'components/atoms/Container'
import NewAptitudeBanner from 'components/molecules/NewAptitudeBanner'
import AuthenticatedLink from 'components/molecules/AuthenticatedLink'

import Relazsizes from 'relazsizes'
import triggerEvent from 'utils/dataLayer'

import { shape, string, object, bool, func } from 'prop-types'

const PromoPictWrapper = ({
  bannerDesktop,
  bannerDesktopAlt,
  bannerMobile,
  bannerMobileAlt,
}) => (
  <Relazsizes
    className="promotion-banner__banner"
    el="picture"
    dataSrcset={[
      {
        media: '(min-width: 576px)',
        srcset: bannerDesktop,
        alt: bannerDesktopAlt,
      },
    ]}
    dataSrc={bannerMobile || bannerDesktop}
    alt={bannerMobileAlt || bannerDesktopAlt}
  />
)

PromoPictWrapper.propTypes = {
  bannerDesktop: string,
  bannerDesktopAlt: string,
  bannerMobile: string,
  bannerMobileAlt: string,
}

const PromotionBanner = ({ promotion, handleGTM }) => {
  const pathname = (typeof window === 'undefined') ? '' : window.location.pathname
  const handleBannerClick = () => {
    if (handleGTM) {
      handleGTM()
    } else {
      const eventName = `ga${pathname}/bannerads/`

      triggerEvent(eventName, {
        url: promotion.url,
      })
    }
  }

  const linkProps = {
    'aria-label': 'Promotion Banner',
    target: '_blank',
    rel: 'noopener',
  }

  if (promotion.bannerDesktop) {
    return (
      <div className="promotion-banner">
        <Container fluid={promotion.noContainer || false} mobileFull>
          {
            promotion.leadsRequired ?
              <AuthenticatedLink
                href={promotion.url}
                onClick={handleBannerClick}
                linkProps={linkProps}
              >
                <PromoPictWrapper {...promotion}/>
              </AuthenticatedLink> :
              <a href={promotion.url} onClick={handleBannerClick} {...linkProps}>
                <PromoPictWrapper {...promotion}/>
              </a>
          }
        </Container>
        <style jsx global>
          {`
            .promotion-banner {
              &__banner {
                width: 100%;
                img {
                  width: 100%;
                  max-height: 384px;
                  object-fit: cover;
                  object-position: center center;
                }
              }
            }
          `}
        </style>
      </div>
    )
  }
  return <NewAptitudeBanner/>
}

PromotionBanner.propTypes = {
  promotion: shape({
    bannerDesktop: string,
    bannerDesktopAlt: string,
    bannerMobile: string,
    bannerMobileAlt: string,
    leadsRequired: bool,
    url: string,
    currentUser: object,
    noContainer: bool,
  }),
  handleGTM: func
}

export default PromotionBanner
